<template>
  <div v-if="nouveauDevisCommande">
    <a ref="lienDownload"></a>
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" v-if="isNewDevisCommande">
                {{ $t('ajoutDevis.title')}}</h1>
              <h1 class="title is-size-3" v-else>
                {{ $t('ajoutDevis.updateTitle')}}&nbsp;n°: {{nouveauDevisCommande.code}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right" v-if="canSeeDevis">
          <div class="buttons">
            <button class="button is-cancel btn-modal-annuler " v-on:click="annuler()">
              {{ $t('ajoutDevis.actions.revert')}}
            </button>
            <button class="button is-addOrEdit "
                    @click="checkBeforeSave()">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <verticalDotsDropdown
              class="mgb-2"
              v-if="isPublid"
              :dropdownItems="dropdownItems"
              :isButton="true"/>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.DEVIS.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                          :error="error"
                          :title="'general.problemOccurred'"
                          :withEmplyFields="true"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          @close="error = $event"/>
      <avertissement-msg-component :messages="messagesWarning"
                                   :avertissement="warning"
                                   :title="'general.warning'"
                                   @close="warning = $event"/>
      <div v-if="!canSeeDevis">
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('general.noAccess') }]"
                                       :canClose="false"
        >
        </app-information-msg-component>
      </div>
    </div>
    <div class="tab" v-if="canSeeDevis">
      <ul>
        <li :class="{'is-active': activeTab === 'ajoutDevisInfosGenerales'}"
            @click="activeTab = 'ajoutDevisInfosGenerales'">
          {{ $t('ajoutDevis.tabs.devis') }}
        </li>
        <li :class="{ 'is-active': activeTab === 'editionAchatDevisCommande' }"
            @click="activeTab = 'editionAchatDevisCommande'"
            v-if="nouveauDevisCommande.role !== constantes.REGIE">
          {{ $t('ajoutDevis.tabs.achats') }}
        </li>
        <li :class="{'is-active': activeTab === 'logistique'}"
            @click="activeTab = 'logistique'">
          <b-field>
            <div class="mgv-auto mgr-5px round-circle-warning"
                  v-if="displayRoundAlerteLogistique"></div>
            <span> {{ $t('ajoutDevis.tabs.logistique') }}</span>
          </b-field>
        </li>
        <li :class="{'is-active': activeTab === 'commissions'}"
            @click="activeTab = 'commissions'" v-if="modulePresseActive">
          {{ $t('ajoutDevis.tabs.commissions') }}
        </li>
        <li :class="{'is-active': activeTab === 'echeancierFacturation'}"
            @click="activeTab='echeancierFacturation'">
          {{ $t('ajoutDevis.tabs.echeancierFacturation') }}
        </li>
        <li :class="{'is-active': activeTab === 'previsualisation'}"
            @click="activeTab = 'previsualisation'">
          {{ $t('ajoutDevis.tabs.previsualisation') }}
        </li>
        <li :class="{'is-active': activeTab === 'etatSuiviDevisCommande'}"
            @click="activeTab = 'etatSuiviDevisCommande'" v-if="modulePresseActive">
          {{ $t('ajoutDevis.tabs.etatSuiviDevisCommande') }}
        </li>
      </ul>
    </div>
    <component v-if="canSeeDevis"
               v-model="nouveauDevisCommande"
               :is="activeTab"
               :dcf="nouveauDevisCommande"
               :plan-media="nouveauDevisCommande"
               :isEditPrevisu="isEditPrevisu"
               :showErrorDate="showErrorDate"
               :isEdit="true"
               :error="error"
               :devis="nouveauDevisCommande"
               :breadcrumb="breadcrumb"
               :isNewDevis="isNewDevisCommande"
               :utilisateur="utilisateur"
               :devisCommande="nouveauDevisCommande"
               :gestionEcheancier="nouveauDevisCommande.gestionEcheancier"
               :commande="nouveauDevisCommande"
               :isDevis="true"
               @regenereEcheancier="regenereEcheancier"
               @deleteOrDeselectPayeurInEcheancier=
                 "deleteOrDeselectPayeurInEcheancier"
               @updateGestionEcheancier="updateGestionEcheancier"
               @changeIsEditPrev="isEditPrevisu = $event"
               @masqueLigneChange="masqueLigneChange"
               @masqueRemiseChange="nouveauDevisCommande.masqueRemise = $event"
               @calcul="calcul"/>
    <b-modal v-model="isComponentPopUpErreurPerso"
      has-modal-card
      class="modal">
      <pop-up-erreur
          :messHeader="$t('ligneRegroupementPersonnalisee.popup.unableToCreate')"
          :messagesPopup="messagesPopup"
      />
    </b-modal>
    <b-modal v-model="popUpOptionBlocage" has-modal-card class="modal"
             @close="updateDataOfDevisAsync">
      <pop-up-prevention
        :messHeader="$t('optionBlocage.popUp.title')"
        :cancel="$t('optionBlocage.popUp.retour')"
        :validate="$t('optionBlocage.popUp.continuer')"
        @no="updateDataOfDevisAsync"
        @yes="goToDetail"
      />
    </b-modal>
    <b-modal v-model="popUpImportExcel"
             has-modal-card
             class="modal">
      <pop-up-import-excel
        :haveAlreadyVente="nouveauDevisCommande.lignesCommande.length > 0"
        @addXlsxFile="readAndCreateLignes">
      </pop-up-import-excel>
    </b-modal>
    <b-modal v-model="popUpProduit" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('ajoutDevis.popUpProduct.title')"
        :messagesHtml="lignesSansProduitMessage"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpProduit = false; lignesSansProduitMessage = []"
        @yes="saveDevis">
        {{ nouveauDevisCommande.lignesCommande.libelle }}
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpChoiceSavePrevisualisation"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('previsualisation.titlePopUp')"
        :cancel="$t('previsualisation.actions.cancel')"
        :validate="$t('previsualisation.actions.saveWithNewPrevisualisation')"
        :otherButton="$t('previsualisation.actions.saveWithoutNewPrevisualisation')"
        @no="popUpChoiceSavePrevisualisation = false"
        @yes="saveWithChange"
        @otherButtonSelect="saveWithoutChange"
      ></pop-up-prevention>
    </b-modal>
    <b-modal v-model="modal.prevention"
             has-modal-card
             class="modal">
      <pop-up-prevention :messHeader="modal.title"
                         :messDescription="modal.subtitle"
                         :validate="$t('general.button.next')"
                         :cancel="$t('general.button.cancel')"
                         @yes="checkAlredyPassErrorDateOrTotal()"
                         @no="displayErrorEcheancier"/>
    </b-modal>
    <b-modal v-model="modal.error"
             has-modal-card
             class="modal">
      <pop-up-erreur
        :messHeader="modal.title"
        :messages="[{ isLink: false, libelle: modal.subtitle }]"
      />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import AppBreadcrumb from '@/components/general/breadcrumb';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import * as devisConf from '@/configuration/devisConf';
import initializeCommandeDevis from '@/services/devisCommandes/initializeCommandeDevis';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import { create, update } from '@/api/devis/index';
import { devisGetterAsync as devisCommandeGetter } from '@/services/devisCommandes/devisCommandeGetter';
import validationGeneral from '@/services/validation/validation';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationLignesCommande from '@/services/dcf/validation/validationVentePartielle';
import translate from '@/services/devisCommandes/validation/champsDevisTranslator';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import addIntervenant from '@/services/devisCommandes/addIntervenant';
import creerIntervenant from '@/services/devisCommandes/creerIntervenant';
import * as types from '@/store/modules/commande-mutation-type';
import * as typesClient from '@/store/modules/clients-mutation-type';
import { GUID_VIDE } from '@/configuration/general';
import preparationEnvoiBack from '@/services/devisCommandes/preparationEnvoiBack/preparationEnvoiBack';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL, ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import {
  ajouterProduitDepuisPanierNumerique,
  ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo,
} from '@/services/devisCommandes/ajoutProduit/ajouterProduitDepuisPanier';
import * as typesProduitNumerique from '@/store/modules/produitEcranNumerique-mutation-type';
import * as typesProduitFace from '@/store/modules/produitFace-mutation-type';
import * as typesProduitReseauTempo from '@/store/modules/planningReseauTempo-mutation-type';
import * as typesProduitReseauLc from '@/store/modules/produitReseauLc-mutation-type';
import * as typesProduitReseauMairie from '@/store/modules/bodac/catalogue/produitReseauMairie-mutation-type';
import popUpErreur from '@/components/general/popUpErreur';
import reordonnancementRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/reordonnancementRegroupementPersonnalise';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import popUpImportExcel from '@/components/devisCommandes/editionDevisCommande/p_importExcel';
import readFileXlsx from '@/services/general/readFileXlsx';
import fromLignesXlsxToTab from '@/services/excel/produitReseauNumerique/fromLignesXlsxToTab';
import { ajoutLignesCommandeProduitReseauNumfromXlsx } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauNumerique';
import {
  CATEGORIE_UNITAIRE,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT, CATEGORIE_SALON, CATEGORIE_SPONSORING, CATEGORIE_AUTRE, CATEGORIE_PRESSE,
} from '@/configuration/catalogue/produitConf';
import categorieVenteInitialize from '@/services/devisCommandes/categorieVenteInitialize';
import { updateAffectionOfAllProduct } from '@/services/affectation/affectation';
import popUpPrevention from '@/components/general/popUpPrevention';
import updateInformationDevisAsync from '@/services/devisCommandes/optionBlocage/updateInformationDevis';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import { updateAffectationProduitTempoFromDevis } from '@/services/affectation/updateAffectationProduitTempoFromDevis';
import ajoutDevisInfosGenerales from '@/components/devis/ajoutDevisInfosGenerales';
import previsualisation
  from '@/components/devisCommandeFacture/previsualisation/previsualisation';
import updateMasqueLigneWithOrdre from '@/services/devisCommandes/ligneCommande/updateMasqueLigneWithOrdre';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import exportExcel from '@/api/exportExcel';
import { TYPE_DONNE_EXPORT_RESEAU_NUM_PUBLID } from '@/configuration/dcf/dcfConf';
import {
  SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO,
  CLEAR_LIGNES_COMMANDE,
} from '@/store/modules/produitReseauTempo-mutation-type';
import { gestionPlanMediaDcf } from '@/services/dcf/planMedia/gestionPlanMediaDcf';
import { addReferenceEcheancierToLigneCommandeWithoutReference } from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import getLignesCommandesWithReferenceEcheancier
  from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';
import { checkUnconsecutiveDateEcheancier } from '@/services/commande/echeancierFacturation/checkUnconsecutiveDateEcheanciers';
import echeancierFacturation from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/echeancierFacturation';
import deleteEcheancierAndReference from '@/services/devisCommandes/preparationEnvoiBack/deleteEcheancierAndReference';
import { REGIE } from '@/configuration/societe/societe';
import { ECRAN_PLAN_MEDIA_DETAIL } from '@/configuration/bodac/planMedia/planMediaConfig';
import editionAchatDevisCommande from '@/components/devisCommandes/achat/editionAchatDevisCommande';
import setAFacturerAndFournisseurIfRegie
  from '@/services/devisCommandes/bonAFacturer/setAFacturerAndFournisseurIfRegie';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/ligneCommande/updateModeCalculHonoraire';
import * as typesProduitSalon from '@/store/modules/bodac/catalogue/produitSalon-mutation-type';
import * as typesProduitSponsoring from '@/store/modules/bodac/catalogue/produitSponsoring-mutation-type';
import * as typesProduitAutre from '@/store/modules/bodac/catalogue/produitAutre-mutation-type';
import regleFacturationInitialize from '@/services/devisCommandes/regleFacturationInitialize';
import * as typesProduitPresse from '@/store/modules/bodac/catalogue/produitPresse-mutation-type';
import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';
import logistique from '@/components/devisCommandes/editionDevisCommande/logistiqueCommande';
import commissions from '@/components/planMedia/edition/commissions';
import etatSuiviDevisCommande from '@/components/devisCommandes/presse/etatSuiviDevisCommande/etatSuiviDevisCommande';
import moment from 'moment';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { DEVIS } from '@/configuration/permissionsBodacConf';
import checkDcfBeforeSave from '@/services/bodac/lignesCommande/critereRecherche/checkBeforeSave';
import validationLigneEcheance from '@/services/devisCommandes/validation/validationLigneEcheance';
import { getSocietePublid } from '@/services/excel/produitReseauNumerique/getProduitsLocForExportImportNum';
import agenceInitialize from '@/services/devisCommandes/agenceInitialize';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';

const produitNumerique = createNamespacedHelpers('produitEcranNumerique');
const produitFace = createNamespacedHelpers('produitFace');
const Commandes = createNamespacedHelpers('commande');
const User = createNamespacedHelpers('user');
const Clients = createNamespacedHelpers('clients');
const Parametres = createNamespacedHelpers('parametres');
const Attachments = createNamespacedHelpers('attachments');
const societe = createNamespacedHelpers('societe');
const ProduitReseauTempo = createNamespacedHelpers('planningReseauTempo');
const ProduitReseauLc = createNamespacedHelpers('produitReseauLc');
const ProduitreseauTempoDispo = createNamespacedHelpers('produitReseauTempo');
const ProduitReseauMairie = createNamespacedHelpers('produitReseauMairie');
const ProduitSalon = createNamespacedHelpers('produitSalon');
const ProduitSponsoring = createNamespacedHelpers('produitSponsoring');
const ProduitAutre = createNamespacedHelpers('produitAutre');
const ProduitPresse = createNamespacedHelpers('produitPresse');

export default {
  props: [],
  components: {
    appBreadcrumb: AppBreadcrumb,
    errorMsgComponent,
    popUpImportExcel,
    popUpPrevention,
    popUpErreur,
    ajoutDevisInfosGenerales,
    previsualisation,
    AppInformationMsgComponent,
    echeancierFacturation,
    editionAchatDevisCommande,
    avertissementMsgComponent,
    logistique,
    commissions,
    etatSuiviDevisCommande,
    pieceJointeButton,
    verticalDotsDropdown,
  },
  data() {
    return {
      warning: false,
      messagesWarning: [],
      error: false,
      messagesPopup: [],
      lignesSansProduitMessage: [],
      isComponentPopUpErreurPerso: false,
      etatEnregistrer: devisConf.ETAT_ENREGISTRE,
      nouveauDevisCommande: null,
      messages: [],
      lignesMessage: [],
      messagesChampsVide: [],
      champsVide: [],
      popUpProduit: null,
      etatLibelle: '',
      popUpImportExcel: false,
      popUpOptionBlocage: false,
      devisUpdated: null,
      activeTab: 'ajoutDevisInfosGenerales',
      isEditPrevisu: false,
      masqueRemiseBase: false,
      lignesMasqueLigneBase: [],
      popUpChoiceSavePrevisualisation: false,
      showErrorDate: false,
      modal: {
        error: false,
        warningDateAlreadyCheck: false,
        warningTotalAlreadyCheck: false,
        title: '',
        subtitle: '',
        warningType: '',
        prevention: false,
      },
      constantes: {
        REGIE,
        DEVIS,
      },
    };
  },
  computed: {
    ...ProduitSalon.mapGetters({
      panierSalon: 'panier',
      useEcranAjoutSalon: 'useEcranAjout',
    }),
    ...ProduitAutre.mapGetters({
      panierAutre: 'panier',
      useEcranAjoutAutre: 'useEcranAjout',
    }),
    ...ProduitPresse.mapGetters({
      panierPresse: 'panier',
      useEcranAjoutPresse: 'useEcranAjout',
    }),
    ...ProduitSponsoring.mapGetters({
      panierSponsoring: 'panier',
      useEcranAjoutSponsoring: 'useEcranAjout',
    }),
    ...ProduitReseauMairie.mapGetters({
      panierReseauMairie: 'panier',
      useEcranAjoutReseauMairie: 'useEcranAjout',
    }),
    ...ProduitreseauTempoDispo.mapGetters({
      lignesCommande: 'lignesCommande',
      isFromListReseauTempoDispo: 'isFromListReseauTempoDispo',
    }),
    ...produitNumerique.mapGetters({
      panierNumerique: 'panier',
      regroupPersoNumerique: 'regroupementPersonnalise',
    }),
    ...produitFace.mapGetters({
      regroupPersoFace: 'regroupementPersonnalise',
      panierFace: 'panier',
      useEcranAjoutFace: 'useEcranAjout',
    }),
    ...ProduitReseauTempo.mapGetters({
      panierReseauTempo: 'panier',
      regroupPersoReseauTempo: 'regroupementPersonnalise',
      useEcranAjoutReseauTempo: 'useEcranAjout',
    }),
    ...ProduitReseauLc.mapGetters({
      panierReseauLc: 'panier',
      regroupPersoReseauLc: 'regroupementPersonnalise',
      useEcranAjoutReseauLc: 'useEcranAjout',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...Commandes.mapGetters({
      commandeCourante: 'commande',
    }),
    ...Clients.mapGetters({
      clientCourant: 'clientCourant',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    isPublid() {
      return !!getSocietePublid();
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeDevis.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeDevis.title'), route: { name: 'l.bodac.devis' }, isActive: false },
        { title: this.$i18n.t('ajoutDevis.title'), route: { name: 'm.bodac.devis-creation' }, isActive: true },
      ];
      if (!this.isNewDevisCommande) {
        output[2].title = this.$i18n.t('ajoutDevis.updateTitle');
        output[2].route = { name: 'm.bodac.devis', params: { id: this.$route.params.id } };
      }
      return output;
    },
    canSeeDevis() {
      if (!this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key)) return true;
      return (this.isNewDevisCommande || this.utilisateur.profil !== COMMERCIAL
        || (this.utilisateur.profil === COMMERCIAL
          && this.utilisateur.id === this.nouveauDevisCommande.commercialId));
    },
    isNewDevisCommande() {
      return this.nouveauDevisCommande
      && (!this.nouveauDevisCommande.id
      || this.nouveauDevisCommande.id === GUID_VIDE);
    },
    isCommercial() {
      return ((this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL)
        || (!this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL
          && this.utilisateur.id === this.nouveauDevisCommande.commercialId));
    },
    intervenantsPayeurs() {
      return this.nouveauDevisCommande.intervenants.filter(i => i.payeur);
    },
    displayRoundAlerteLogistique() {
      return (this.nouveauDevisCommande.lignesCommande.some((ligne) => {
        return (ligne.typeProduit === CATEGORIE_UNITAIRE
          && ligne.datePlanifieeLogistiqueAffichage
          && !moment(ligne.datePlanifieeLogistiqueAffichage).isSame(moment(ligne.dateDebut))
          || ligne.isAffecteLogistiquement
        );
      }));
    },
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    dropdownItems() {
      return [
        {
          action: () => this.getExcelProduitReseauNum(),
          libelle: this.$t('exportExcelReseauNum.exportExcel'),
          id: 0,
        },
        {
          action: () => { this.popUpImportExcel = true; },
          libelle: this.$t('exportExcelReseauNum.importExcel'),
          id: 1,
        },
      ];
    },
  },
  methods: {
    ...Commandes.mapMutations({
      removeCommande: types.REMOVE_COMMANDE,
    }),
    ...ProduitreseauTempoDispo.mapMutations({
      setIsFromListReseauTempoDispo: SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO,
      clearLignesCommande: CLEAR_LIGNES_COMMANDE,
    }),
    ...Clients.mapMutations({
      setClientCourant: typesClient.SET_CLIENT_COURANT,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...produitNumerique.mapMutations({
      clearBriefNumerique: typesProduitNumerique.CLEAR_BRIEF,
      clearPanierNumerique: typesProduitNumerique.CLEAR_PANIER,
    }),
    ...ProduitReseauTempo.mapMutations({
      clearBriefReseauTempo: typesProduitReseauTempo.CLEAR_BRIEF,
      clearPanierReseauTempo: typesProduitReseauTempo.CLEAR_PANIER,
      setTypeDCFReseauTempo: typesProduitReseauTempo.SET_TYPE_DCF,
      setUseEcranAjoutReseauTempo: typesProduitReseauTempo.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitReseauMairie.mapMutations({
      clearBriefReseauMairie: typesProduitReseauMairie.CLEAR_BRIEF,
      clearPanierReseauMairie: typesProduitReseauMairie.CLEAR_PANIER,
      setTypeDCFReseauMairie: typesProduitReseauMairie.SET_TYPE_DCF,
      setUseEcranAjoutReseauMairie: typesProduitReseauMairie.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitReseauLc.mapMutations({
      clearBriefReseauLc: typesProduitReseauLc.CLEAR_BRIEF,
      clearPanierReseauLc: typesProduitReseauLc.CLEAR_PANIER,
      setTypeDCFReseauLc: typesProduitReseauLc.SET_TYPE_DCF,
      setUseEcranAjoutReseauLc: typesProduitReseauLc.SET_USE_ECRAN_AJOUT,
    }),
    ...produitFace.mapMutations({
      clearBriefFace: typesProduitFace.CLEAR_BRIEF,
      clearPanierFace: typesProduitFace.CLEAR_PANIER,
      setTypeDCFFace: typesProduitFace.SET_TYPE_DCF,
      setUseEcranAjoutFace: typesProduitFace.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitSalon.mapMutations({
      clearBriefSalon: typesProduitSalon.CLEAR_BRIEF,
      clearPanierSalon: typesProduitSalon.CLEAR_PANIER,
      setTypeDCFSalon: typesProduitSalon.SET_TYPE_DCF,
      setUseEcranAjoutSalon: typesProduitSalon.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitSponsoring.mapMutations({
      clearBriefSponsoring: typesProduitSponsoring.CLEAR_BRIEF,
      clearPanierSponsoring: typesProduitSponsoring.CLEAR_PANIER,
      setTypeDCFSponsoring: typesProduitSponsoring.SET_TYPE_DCF,
      setUseEcranAjoutSponsoring: typesProduitSponsoring.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitAutre.mapMutations({
      clearBriefAutre: typesProduitAutre.CLEAR_BRIEF,
      clearPanierAutre: typesProduitAutre.CLEAR_PANIER,
      setTypeDCFAutre: typesProduitAutre.SET_TYPE_DCF,
      setUseEcranAjoutAutre: typesProduitAutre.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitPresse.mapMutations({
      clearBriefPresse: typesProduitPresse.CLEAR_BRIEF,
      clearPanierPresse: typesProduitPresse.CLEAR_PANIER,
      setTypeDCFPresse: typesProduitPresse.SET_TYPE_DCF,
      setUseEcranAjoutPresse: typesProduitPresse.SET_USE_ECRAN_AJOUT,
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    getRemiseTvaDefaut(devis) {
      const agenceFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === devis.agenceId;
      });
      const regimesTva = this.parametre(typesParametres.PARAMETRES_KEYS.regimeTva);
      if (!agenceFind.regimeTvaId) return null;
      const regimeFind = regimesTva.find((regime) => {
        return regime.id === agenceFind.regimeTvaId;
      });
      return regimeFind ? regimeFind.tauxTva : null;
    },
    regenereEcheancier() {
      deleteEcheancierAndReference(this.nouveauDevisCommande);
      addReferenceEcheancierToLigneCommandeWithoutReference(this.nouveauDevisCommande);
    },
    checkBeforeSave() {
      this.lignesSansProduitMessage = checkDcfBeforeSave(this.nouveauDevisCommande);
      if (this.lignesSansProduitMessage.length) {
        this.popUpProduit = true;
      } else this.enregistrerDevisCommande();
    },
    saveDevis() {
      this.popUpProduit = false;
      this.enregistrerDevisCommande();
    },
    deleteOrDeselectPayeurInEcheancier(isDelete) {
      this.modal.error = true;
      this.modal.title = this.$i18n.t('echeancierFacturation.messages.errors.' + (isDelete ? 'payeurDelete' : 'payeurDeselect') + '.title');
      this.modal.subtitle = this.$i18n.t('echeancierFacturation.messages.errors.' + (isDelete ? 'payeurDelete' : 'payeurDeselect') + '.subTitle');
    },
    updateGestionEcheancier(newValueGestionEcheancier) {
      this.nouveauDevisCommande.gestionEcheancier = newValueGestionEcheancier;
    },
    displayErrorEcheancier() {
      this.modal.prevention = false;
      if (this.modal.warningType === 'date') this.showErrorDate = true;
      this.modal.warningTotalAlreadyCheck = false;
      this.modal.warningDateAlreadyCheck = false;
    },
    checkTotalError() {
      if (this.modal.warningTotalAlreadyCheck) return false;
      let errorTotal = false;
      this.nouveauDevisCommande.echeanciers.forEach((echeancier) => {
        if (echeancier.quantitePeriodicite === 0) return;
        const lignesCommandeWithReference = getLignesCommandesWithReferenceEcheancier(
          this.nouveauDevisCommande.lignesCommande, echeancier.referenceEcheancier,
        );
        const totalEcheanciers = echeancier.echeancierLignes.length > 0
          ? echeancier.echeancierLignes
            .map((ligne) => { return ligne.montant; })
            .reduce((montantTotal, montant) => montantTotal + montant) : 0;
        const totalLignesCommande = lignesCommandeWithReference
          .map((ligne) => { return ligne.totalHtAvecLigneRemise; })
          .reduce((montantTotal, montant) => montantTotal + montant);
        if (totalEcheanciers.toFixed(2) !== totalLignesCommande.toFixed(2)) errorTotal = true;
      });
      if (!errorTotal) return false;
      this.modal.title = this.$i18n.t('echeancierFacturation.messages.prevention.total_different.title');
      this.modal.subtitle = this.$i18n.t('echeancierFacturation.messages.prevention.total_different.subTitle');
      this.modal.warningType = 'total';
      this.modal.prevention = true;
      return true;
    },
    checkDateError() {
      if (this.modal.warningDateAlreadyCheck) return false;
      const unconsecutiveDate = checkUnconsecutiveDateEcheancier(
        this.nouveauDevisCommande.echeanciers, this.intervenantsPayeurs,
      );
      if (!unconsecutiveDate) return false;
      this.modal.title = this.$i18n.t('echeancierFacturation.messages.prevention.unconsecutive_date.title');
      this.modal.subtitle = this.$i18n.t('echeancierFacturation.messages.prevention.unconsecutive_date.subTitle');
      this.modal.warningType = 'date';
      this.modal.prevention = true;
      return true;
    },
    checkAlredyPassErrorDateOrTotal() {
      this.modal.prevention = false;
      if (this.modal.warningType === 'date') this.modal.warningDateAlreadyCheck = true;
      else this.modal.warningTotalAlreadyCheck = true;
      this.enregistrerDevisCommande();
    },
    masqueLigneChange(ligne) {
      updateMasqueLigneWithOrdre(
        this.nouveauDevisCommande.lignesCommande, ligne.ordre, !ligne.masqueLigne,
      );
    },
    changeMasqueLigneToInitalMasqueLigne(lignesCommande) {
      lignesCommande.forEach((ligne) => {
        if (ligne.lignesCommande) {
          ligne.lignesCommande.forEach((ligneEnfant) => {
            const ligneInitial = this.lignesMasqueLigneBase.find((ligne) => {
              return ligneEnfant.id && ligne.id === ligneEnfant.id;
            });
            if (ligneInitial) ligneEnfant.masqueLigne = ligneInitial.masqueLigne;
            else ligneEnfant.masqueLigne = false;
          });
        }
      });
    },
    getLignesMasqueLigne(lignesCommande) {
      lignesCommande.forEach((ligne) => {
        if (ligne.lignesCommande) {
          const lignesFind = ligne.lignesCommande.filter((ligneEnfant) => {
            return ligneEnfant.masqueLigne && ligneEnfant.id;
          });
          if (lignesFind) {
            this.lignesMasqueLigneBase = this.lignesMasqueLigneBase.concat(cloneDeep(lignesFind));
          }
        }
      });
    },
    saveWithChange() {
      this.popUpChoiceSavePrevisualisation = false;
      this.isEditPrevisu = false;
      this.enregistrerDevisCommande();
    },
    saveWithoutChange() {
      this.popUpChoiceSavePrevisualisation = false;
      this.isEditPrevisu = false;
      this.nouveauDevisCommande.masqueRemise = this.masqueRemiseBase;
      this.changeMasqueLigneToInitalMasqueLigne(this.nouveauDevisCommande.lignesCommande);
      this.enregistrerDevisCommande();
    },
    async updateDataOfDevisAsync() {
      this.popUpOptionBlocage = false;
      const devis = await updateInformationDevisAsync(this.devisUpdated);
      if (!this.nouveauDevisCommande.gestionEcheancier) {
        addReferenceEcheancierToLigneCommandeWithoutReference(devis);
      }
      this.nouveauDevisCommande = devis;
      this.calcul();
    },
    goToDetail() {
      this.$router.push({ name: 'c.bodac.devis', params: { id: this.devisUpdated.id } });
    },
    async getExcelProduitReseauNum() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: TYPE_DONNE_EXPORT_RESEAU_NUM_PUBLID,
          nomFichier: '',
          typeExport: '',
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        messageSucces(this.$i18n.t('exportExcelReseauNum.messages.sucessCreationExcel'));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('exportExcelReseauNum.messages.excelExportError'));
        loadingComponent.close();
        throw (e);
      }
    },
    async readAndCreateLignes(file) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const lignesXlsx = await readFileXlsx(file);
        const tabDonnnes = fromLignesXlsxToTab(lignesXlsx);
        if (tabDonnnes.length === 0) throw new Error();
        await ajoutLignesCommandeProduitReseauNumfromXlsx(
          this.nouveauDevisCommande, tabDonnnes,
          this.$i18n, this.getRemiseTvaDefaut(this.nouveauDevisCommande),
        );
        this.changeOrder();
        this.calcul();
        this.findNewTypeProduit();
        messageSucces(this.$i18n.t('importExcel.messages.sucessCreationLignes'));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('importExcel.messages.errorCreationLignes'));
        loadingComponent.close();
        throw (e);
      }
    },
    findNewTypeProduit() {
      categorieVenteInitialize(this.nouveauDevisCommande);
    },
    calcul() {
      calculCommandeDevis(this.nouveauDevisCommande);
      if (this.modulePresseActive && !this.nouveauDevisCommande.regleFacturationId) {
        regleFacturationInitialize(this.nouveauDevisCommande);
      }
    },
    async enregistrerDevisCommande() {
      if (this.isEditPrevisu) {
        this.popUpChoiceSavePrevisualisation = true;
        return;
      }
      if (this.nouveauDevisCommande.gestionEcheancier && this.checkTotalError()) return;
      if (this.nouveauDevisCommande.gestionEcheancier && this.checkDateError()) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.error = false;
        if (this.isCommercial) this.nouveauDevisCommande.commercialId = this.utilisateur.id;
        const copieNouveauDevisCommande = preparationEnvoiBack(this.nouveauDevisCommande);
        if (!this.nouveauDevisCommande.gestionEcheancier) {
          deleteEcheancierAndReference(copieNouveauDevisCommande);
        }
        setAFacturerAndFournisseurIfRegie(this.nouveauDevisCommande);
        let devis = {};
        if (this.isNewDevisCommande) {
          devis = (await create(copieNouveauDevisCommande)).data.result;
          await this.insertAttachments(devis.id);
          messageSucces(this.$i18n.t('ajoutDevis.messages.successCreation'));
        } else {
          devis = (await update(copieNouveauDevisCommande)).data.result;
          await this.updateAttachments(devis.id);
          messageSucces(this.$i18n.t('ajoutDevis.messages.editQuotationSuccess'));
        }
        loadingComponent.close();
        if (devis.messagesAvertissement === null) {
          if (this.$route.params.planMediaId) {
            this.goToPlanMedia();
            return;
          }
          this.$router.push({
            name: 'c.bodac.devis',
            params: { id: devis.id },
          });
          return;
        }
        this.popUpOptionBlocage = true;
        devis.gestionEcheancier = this.nouveauDevisCommande.gestionEcheancier;
        this.devisUpdated = devis;
        await this.setAttachmentElementId({ id: this.devisUpdated.id });
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          validationDevisCommande(e.response,
            this.messages,
            this.isNewDevisCommande,
            devisConf.TYPE_DEVIS);
          await validationLignesCommande(e.response, this.messages, this.nouveauDevisCommande);
          validationLigneEcheance(e.response, this.messages,
            this.nouveauDevisCommande.lignesCommande, devisConf.TYPE_DEVIS);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    annuler() {
      if (this.$route.params.planMediaId) {
        this.goToPlanMedia();
        return;
      }
      this.$router.go(-1);
    },
    goToPlanMedia() {
      let nameRoutePlanMedia = 'm.presse.plan_media-edit';
      if (this.$route.params?.typeEcran === ECRAN_PLAN_MEDIA_DETAIL) {
        nameRoutePlanMedia = 'c.presse.plan_media';
      }
      this.$router.push({
        name: nameRoutePlanMedia,
        params: { id: this.$route.params.planMediaId },
      });
    },
    changeOrder() {
      // On réordonne les éléments liées à un réseau personnalisé
      // pour les mettre en dessous de la ligne de réseau personnalisé
      reordonnancementRegroupementPersonnalise(this.nouveauDevisCommande.lignesCommande);
      this.nouveauDevisCommande.lignesCommande.forEach((ligneCommande) => {
        ajoutOrdre(ligneCommande, this.nouveauDevisCommande.lignesCommande.indexOf(ligneCommande));
      });
      this.calcul();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.messagesWarning = [];
      this.warning = false;
      this.setTypeDCFFace(devisConf.TYPE_DEVIS);
      this.setTypeDCFReseauLc(devisConf.TYPE_DEVIS);
      this.setTypeDCFReseauTempo(devisConf.TYPE_DEVIS);
      this.setTypeDCFReseauMairie(devisConf.TYPE_DEVIS);
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.regimeTva]);
      await this.loadParametreUtilisateur();
      await this.loadParametresInterne([typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      await this.setAttachmentContext({ module: 'Devis' });
      if (this.commandeCourante) {
        let nouveauDevisCommande = this.commandeCourante;
        this.masqueRemiseBase = nouveauDevisCommande.masqueRemise;
        this.getLignesMasqueLigne(nouveauDevisCommande.lignesCommande);
        const messages = [];
        nouveauDevisCommande = await ajouterProduitDepuisPanierNumerique(
          this.panierNumerique, nouveauDevisCommande, this.regroupPersoNumerique,
          this.$i18n, messages, this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        if (this.useEcranAjoutReseauTempo) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierReseauTempo, nouveauDevisCommande, this.regroupPersoReseauTempo, this.$i18n,
            messages, CATEGORIE_REGROUPEMENT, this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefReseauTempo();
          this.clearPanierReseauTempo();
          this.setUseEcranAjoutReseauTempo(false);
        }
        if (this.useEcranAjoutFace) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierFace, nouveauDevisCommande, this.regroupPersoFace, this.$i18n, messages,
            CATEGORIE_UNITAIRE, this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefFace();
          this.clearPanierFace();
          this.setUseEcranAjoutFace(false);
        }
        if (this.useEcranAjoutReseauLc) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierReseauLc, nouveauDevisCommande, this.regroupPersoReseauLc,
            this.$i18n, messages, CATEGORIE_REGROUPEMENT_LC,
            this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefReseauLc();
          this.clearPanierReseauLc();
          this.setUseEcranAjoutReseauLc(false);
        }
        if (this.useEcranAjoutReseauMairie) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierReseauMairie, nouveauDevisCommande, false,
            this.$i18n, messages, CATEGORIE_REGROUPEMENT_MAIRIE,
            this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefReseauMairie();
          this.clearPanierReseauMairie();
          this.setUseEcranAjoutReseauMairie(false);
        }
        if (this.useEcranAjoutSalon) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierSalon, nouveauDevisCommande, false,
            this.$i18n, messages, CATEGORIE_SALON,
            this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefSalon();
          this.clearPanierSalon();
          this.setUseEcranAjoutSalon(false);
        }
        if (this.useEcranAjoutSponsoring) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierSponsoring, nouveauDevisCommande, false,
            this.$i18n, messages, CATEGORIE_SPONSORING,
            this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefSponsoring();
          this.clearPanierSponsoring();
          this.setUseEcranAjoutSponsoring(false);
        }
        if (this.useEcranAjoutAutre) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierAutre, nouveauDevisCommande, false,
            this.$i18n, messages, CATEGORIE_AUTRE,
            this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefAutre();
          this.clearPanierAutre();
          this.setUseEcranAjoutAutre(false);
        }
        if (this.useEcranAjoutPresse) {
          nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
            this.panierPresse, nouveauDevisCommande, false,
            this.$i18n, messages, CATEGORIE_PRESSE,
            this.getRemiseTvaDefaut(nouveauDevisCommande),
          );
          this.clearBriefPresse();
          this.clearPanierPresse();
          this.setUseEcranAjoutPresse(false);
        }
        await updateAffectionOfAllProduct(nouveauDevisCommande);
        await updateAffectationProduitTempoFromDevis(nouveauDevisCommande);
        if (this.societeActive.roles.length > 0 && !nouveauDevisCommande.role) {
          nouveauDevisCommande.role = this.societeActive.roles[0];
        }
        await updateModeCalculHonoraireLigneCommandeHonoraire(
          nouveauDevisCommande.lignesCommande,
          nouveauDevisCommande.intervenants,
        );
        this.nouveauDevisCommande = nouveauDevisCommande;
        if (this.nouveauDevisCommande.msgAvertissementVentePartielle
          && this.nouveauDevisCommande.msgAvertissementVentePartielle.length > 0) {
          this.warning = true;
          this.messagesWarning = cloneDeep(
            this.nouveauDevisCommande.msgAvertissementVentePartielle,
          );
          delete this.nouveauDevisCommande.msgAvertissementVentePartielle;
        }
        this.clearBriefNumerique();
        this.clearPanierNumerique();
        this.removeCommande();
        if ((this.regroupPersoNumerique && this.panierNumerique)
          || (this.regroupPersoFace && this.panierFace.length > 0)
          || (this.regroupPersoReseauLc && this.panierReseauLc.length > 0)
          || (this.regroupPersoReseauTempo && this.panierReseauTempo.length > 0)) {
          this.changeOrder();
          if (messages.length > 0) {
            this.messagesPopup = messages;
            this.isComponentPopUpErreurPerso = true;
          }
        }
        if (this.$route.name === 'm.bodac.devis-client') {
          addIntervenant(this.nouveauDevisCommande, creerIntervenant(this.clientCourant));
          this.setClientCourant(null);
        }
        this.findNewTypeProduit();
      } else {
        this.id = this.$route.params.id;
        let nouveauDevisCommande = null;
        if (this.id) {
          nouveauDevisCommande = { ...(await devisCommandeGetter(this.id)) };
          nouveauDevisCommande.lignesCommande.forEach((ligne) => {
            ligne.affectation = [];
            ligne.selected = false;
            ligne.messagesAvertissement = null;
            ligne.etatProvisoire = AUCUN;
            if (this.societeActive.roleParDefaut !== REGIE && ligne.lignesCommande.length === 0) {
              ligne.libelleFournisseur = null;
            }
            ligne.lignesCommande.forEach((ligneEnfant) => {
              ligneEnfant.etatObtenu = ligne.etatObtenu;
              ligneEnfant.etatSouhaite = ligne.etatSouhaite;
              ligneEnfant.dateEtatObtenu = ligne.dateEtatObtenu;
              ligneEnfant.dateEtatSouhaite = ligne.dateEtatSouhaite;
              if (this.societeActive.roleParDefaut !== REGIE) {
                ligneEnfant.libelleFournisseur = null;
              }
            });
          });
          await updateAffectionOfAllProduct(nouveauDevisCommande);
          await updateAffectationProduitTempoFromDevis(nouveauDevisCommande);
          nouveauDevisCommande.gestionEcheancier = nouveauDevisCommande.echeanciers.length > 0;
          addReferenceEcheancierToLigneCommandeWithoutReference(nouveauDevisCommande);
          this.masqueRemiseBase = nouveauDevisCommande.masqueRemise;
          this.getLignesMasqueLigne(nouveauDevisCommande.lignesCommande);
          loadingComponent.close();
        } else {
          nouveauDevisCommande = genererDevisCommande(
            devisConf.TYPE_DEVIS,
            devisConf.NORMAL,
            this.societeActive,
            devisConf.SENS_VENTE,
            devisConf.MODULE_GESTION_COMMERCIALE,
          );
          agenceInitialize(nouveauDevisCommande);
          if (this.utilisateur.profil === ASSISTANT_COMMERCIAL) {
            nouveauDevisCommande.assistantId = this.utilisateur.id;
          }
          if (this.utilisateur.profil === COMMERCIAL) {
            nouveauDevisCommande.commercialId = this.utilisateur.id;
            nouveauDevisCommande.commissions = [{
              commercialId: this.utilisateur.id,
              pourcentageRepartition: 100,
              selected: false,
            }];
          }
          if (this.isFromListReseauTempoDispo) {
            nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
              this.lignesCommande, nouveauDevisCommande, false, this.$i18n, [],
              CATEGORIE_REGROUPEMENT, this.getRemiseTvaDefaut(nouveauDevisCommande),
            );
            this.clearLignesCommande();
            await updateAffectationProduitTempoFromDevis(nouveauDevisCommande);
          }
          if (this.societeActive.roles.length > 0) {
            nouveauDevisCommande.role = this.societeActive.roles[0];
          }
          const planMedia = await gestionPlanMediaDcf(nouveauDevisCommande,
            this.$route.params.planMediaId);
          nouveauDevisCommande.planMedia = planMedia;
        }
        initializeCommandeDevis(nouveauDevisCommande);
        this.nouveauDevisCommande = nouveauDevisCommande;
        this.findNewTypeProduit();
      }
      if (this.nouveauDevisCommande.id) {
        await this.setAttachmentElementId({ id: this.nouveauDevisCommande.id });
      }

      const etat = devisConf.DEVIS_COMMANDE_ETAT.find((el) => {
        return el.code === this.nouveauDevisCommande.etat;
      });
      if (etat) {
        this.etatLibelle = etat.libelle;
      }

      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
    if (this.isNewDevisCommande) {
      this.setInformationPage(this.$t('pageGescom.devis.creation'));
    } else {
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.nouveauDevisCommande.code }));
    }
  },
};
</script>

<style>
</style>
